module.exports = __webpack_public_path__ + "img/s2_t2_02.fb37339a.jpeg";